import { OFFER_LIST_CONSTANTS, OFFERS_PER_PAGE, OFFERS_WITHOUT_ADS_PER_PAGE } from 'utils/constants.ts';
import { AdCard } from 'components/offer/card/AdCard.tsx';
import BottomAd from 'components/bottomAd/BottomAd.tsx';
import { ZONE_IDS } from 'components/sspAdverts/sspAdvertsConstants.ts';
import { type AdInserter } from 'components/offer/list/OfferList';

export const searchPageAdInserter: AdInserter = (offers, offersListJSX, _mainOffer, isMobileBannerAbtest) => {
	const newOfferListJsx = [...offersListJSX]; // copy array to avoid mutation

	const maxOffersAtPage = (offers.length / OFFERS_WITHOUT_ADS_PER_PAGE) * OFFERS_WITHOUT_ADS_PER_PAGE;
	const initialPageLength =
		newOfferListJsx.length <= OFFERS_WITHOUT_ADS_PER_PAGE ? newOfferListJsx.length : OFFERS_WITHOUT_ADS_PER_PAGE;

	let pointer = 0;
	for (let i = initialPageLength; i <= maxOffersAtPage; i += OFFERS_WITHOUT_ADS_PER_PAGE) {
		if (i >= OFFER_LIST_CONSTANTS.OFFERS_MIN_COUNT) {
			const id = `firstMoneyOffer-${pointer}`;
			newOfferListJsx.splice(
				pointer + OFFER_LIST_CONSTANTS.AD_MIN_COUNT_POS,
				0,
				<AdCard id={id} offers={offers} key={id} advertZoneId={ZONE_IDS.VYPIS_INZERATU_ASTRO} />,
			);
		}

		if (i >= OFFER_LIST_CONSTANTS.OFFERS_MAX_COUNT) {
			const id = `secondMoneyOffer-${pointer}`;
			newOfferListJsx.splice(
				pointer + OFFER_LIST_CONSTANTS.AD_MAX_COUNT_POS,
				0,
				<AdCard id={id} offers={offers} key={id} advertZoneId={ZONE_IDS.VYPIS_INZERATU_ASTRO} />,
			);
		}

		if (isMobileBannerAbtest) {
			const iteratingPage = i / OFFERS_WITHOUT_ADS_PER_PAGE;
			const id = `offers-mobile-banner-${pointer}`;
			newOfferListJsx.splice(
				pointer + OFFER_LIST_CONSTANTS.ABTEST_BANNER_AD_MAX_COUNT_POS + iteratingPage - 1,
				0,
				<div className="col-span-full md:hidden">
					<BottomAd
						className="my-0 mb-1.5"
						elementId={id}
						mobileCollocation="varA vypis"
						mobileZoneId={ZONE_IDS.PATICKA_MOBIL_TEST}
					/>
				</div>,
			);
		}

		pointer += OFFERS_PER_PAGE;
	}

	if (initialPageLength === OFFER_LIST_CONSTANTS.OFFERS_POPULAR_COUNT) {
		newOfferListJsx.splice(
			OFFER_LIST_CONSTANTS.OFFERS_POPULAR_COUNT,
			0,
			<AdCard
				id="secondPopularMoneyOffer"
				offers={offers}
				key="secondPopularMoneyOffer"
				advertZoneId={ZONE_IDS.VYPIS_INZERATU_ASTRO}
			/>,
		);
	}

	return newOfferListJsx;
};
